import { Control, FieldArrayWithId } from 'react-hook-form'

import { TextInput } from 'components/FormUtils/TextInput'
import { EmailBodyEditor } from './EmailBodyEditor'

export interface SequenceStepForm {
  id?: number // Bison step ID - present for existing steps, undefined for new
  email_subject: string
  email_body: string
  wait_in_days: number
}

export interface SequenceForm {
  title: string
  steps: SequenceStepForm[]
}

export const defaultStep: SequenceStepForm = {
  email_subject: '',
  email_body: '',
  wait_in_days: 1,
}

interface SequenceStepFormItemProps {
  field: FieldArrayWithId<SequenceForm, 'steps', 'id'>
  index: number
  control: Control<SequenceForm>
  canRemove: boolean
  isLast: boolean
  onRemove: () => void
}

export function SequenceStepFormItem({
  field,
  index,
  control,
  canRemove,
  isLast,
  onRemove,
}: SequenceStepFormItemProps) {
  return (
    <div
      key={field.id}
      className="border border-gray-200 rounded-lg p-4 bg-gray-50"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center text-sm font-medium text-blue-600">
            {index + 1}
          </span>
          <span className="text-sm font-medium text-gray-700">
            Step {index + 1}
          </span>
        </div>
        {canRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="text-sm text-red-600 hover:text-red-800"
          >
            Remove
          </button>
        )}
      </div>

      <div className="space-y-3">
        <TextInput
          name={`steps.${index}.email_subject`}
          control={control}
          label="Subject"
          placeholder="Email subject line"
          rules={{ required: 'Subject is required' }}
        />

        <EmailBodyEditor
          name={`steps.${index}.email_body`}
          control={control}
          label="Body"
          placeholder="Write your email content here..."
        />

        {!isLast && (
          <TextInput
            name={`steps.${index}.wait_in_days`}
            control={control}
            label="Wait before next step (days)"
            type="number"
            placeholder="Days to wait before next step"
            rules={{
              required: 'Wait time is required',
              min: { value: 0, message: 'Must be 0 or greater' },
            }}
          />
        )}
      </div>
    </div>
  )
}
